// đang chỉnh sửa - join class
// import StudentJoinClass from "modules/StudentModule/JoinClass";

import OnlineGames from 'modules/OnlineGamesModule';
import SampleTest from 'modules/SampleTest';
import UnitTest from 'modules/SampleTest/UnitTest';
import Tests from 'modules/SampleTest/Tests';
import Shared_Home from 'pages/Home';

// import Login from "./modules/Login/components/FormLoginDesign/index";

// import ActiveCourses from "components/Error/ActiveCode";
// import Profile from 'modules/profileModule/ChangeProfile/components/Profile';

// OLYMPIC
import RegisterStudent from 'modules/Login/components/RegisterStudent';
import React from 'react';
import { FaCogs } from 'react-icons/fa';
import colors from 'constants/colors';
import EducationGame from 'pages/EducationGame';
import Notifications from 'pages/Notifications/Notifications';

export default [
  {
    path: '/home',
    name: 'Trang chủ',
    miniName: 'D',
    component: Shared_Home,
    icon: 'fas fa-home text-info',
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    showInSidebar: true,
    sortOrder: 0,
  },
  {
    path: '/notifications',
    name: 'Thông báo',
    miniName: 'N',
    component: Notifications,
    icon: (
      <i
        className='ni ni-bell-55'
        style={{
          color: 'blue',
          // fontSize: 20,
        }}
      />
    ),
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    showInSidebar: true,
    sortOrder: 0,
  },
  {
    collapse: true,
    name: 'Công cụ',
    icon: <FaCogs style={{ color: colors.font }} />,
    roles: ['authenticated'],
    showInSidebar: true,
    sortOrder: 3,
    state: 'lms/tools',
    views: [
      {
        path: '/tools',
        layout: '/lms',
        exact: true,
        roles: ['authenticated'],
      },
      // {
      //   path: '/tools/dictionary',
      //   name: 'Từ điển',
      //   miniName: 'D',
      //   component: React.lazy(() => import('pages/Tools/Dictionary')),
      //   layout: '/lms',
      //   exact: true,
      //   roles: ['authenticated'],
      //   showInSidebar: true,
      //   sortOrder: 0,
      // },
      {
        path: '/tools/translate',
        name: 'Dịch văn bản',
        miniName: 'D',
        component: React.lazy(() => import('pages/Tools/Translate')),
        layout: '/lms',
        exact: true,
        roles: ['authenticated'],
        showInSidebar: true,
        sortOrder: 1,
      },
    ],
  },
  {
    path: '/education-game',
    name: 'Education Game',
    miniName: 'G',
    component: EducationGame,
    icon: 'fas fa-gamepad text-blue',
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    sortOrder: 102,
    showInSidebar: true,
  },

  // {
  //   path: '/activated-books/',
  //   name: 'Sách điện tử',
  //   miniName: 'B',
  //   component: Shared_ActivatedBooks,
  //   icon: 'fas fa-book text-orange',
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['authenticated'],
  //   showInSidebar: true,
  // },

  // {
  //   path: '/classes-assignments-list',
  //   name: 'Online Practice',
  //   miniName: 'S',
  //   component: AssignmentList,
  //   icon: 'fas fa-home text-info',
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['authenticated'],
  //   showInSidebar: false,
  //   sortOrder: 0,
  // },
  // {
  //   path: "/student/Join-Class",
  //   name: "Khóa Học",
  //   miniName: "S",
  //   component: StudentJoinClass,
  //   icon: "fas fa-graduation-cap text-green",
  //   // icon: "fas fa-home text-info",
  //   layout: "/sgk",
  //   exact: true,
  // },
  // {
  //   path: '/student/Join-Class/Group-Class/:id/:studentId/:year/:month',
  //   name: 'GroupClass', //trùng tên với GroupClass thì sẽ ko hiện ra sidebar
  //   miniName: 'G',
  //   component: AssessmentStudentDetail,
  //   icon: 'fas fa-graduation-cap text-green',
  //   // icon: "fas fa-home text-info",
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['teacher'],
  // },
  // {
  //   path: '/student/Join-Class/Group-Class/:id',
  //   name: 'GroupClass',
  //   miniName: 'G',
  //   component: GroupComponent,
  //   icon: 'fas fa-graduation-cap text-green',
  //   // icon: "fas fa-home text-info",
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['student'],
  //   showInSidebar: false,
  //   sortOrder: 0,
  // },
  // {
  //   path: '/student/Join-Class',
  //   name: 'Lớp học',
  //   miniName: 'S',
  //   component: StudentJoinClass,
  //   icon: 'fas fa-pencil-alt text-orange ',
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['authenticated'],
  // },
  // {
  //   path: '/teacher/Join-Class',
  //   name: 'Lớp học',
  //   miniName: 'S',
  //   component: StudentJoinClass,
  //   icon: 'fas fa-pencil-alt text-orange ',
  //   layout: '/lms',
  //   exact: true,
  //   role: 'teacher'
  // },

  // -------- student learning outcomes -----------
  // {
  //   path: '/student/Result',
  //   name: 'Kết quả',
  //   miniName: 'S',
  //   component: ScoreResult,
  //   icon: 'fas fa-poll text-purple',
  //   layout: '/lms',
  //   exact: true,
  // },
  // {
  //   path: "/calendar",
  //   name: "Lịch",
  //   miniName: "C",
  //   component: Calendar,
  //   icon: "fas fa-calendar-alt text-info",
  //   layout: "/sgk",
  //   // exact: true,
  // },

  // Teacher
  // {
  //   path: '/teacher/create-class',
  //   name: 'Create-Class',
  //   miniName: 'C',
  //   icon: 'ni ni-ungroup text-orange',
  //   component: CreateClass,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['teacher'],
  // },
  // {
  //   path: '/teacher/class/:classId/add-student',
  //   name: 'Thêm học sinh',
  //   miniName: 'C',
  //   icon: 'ni ni-hat-3',
  //   component: AddStudent,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['teacher'],
  // },
  // {
  //   path: '/teacher/Result-Student-In-Class',
  //   name: 'Kết Quả',
  //   miniName: 'C',
  //   icon: 'ni ni-ungroup text-orange',
  //   component: ResultClass,
  //   layout: '/lms',
  //   exact: true,
  //   roles: ['teacher'],
  // },

  // Parent
  // Student StudentJoinClass
  // {
  //   path: "/student/Result",
  //   name: "Study result",
  //   miniName: "R",
  //   icon: "ni ni-single-copy-04 text-orange",
  //   component: ScoreResult,
  //   layout: "/sgk",
  //   exact: true,
  // },
  // {
  //   path: "/student/Join-Class",
  //   name: "Join class",
  //   miniName: "R",
  //   icon: "fas fa-user-graduate text-danger",
  //   component: StudentJoinClass,
  //   layout: "/sgk",
  //   exact: true,
  // },
  // Active classes
  // {
  //   path: "/activeCourses",
  //   name: "Add a book",
  //   miniName: "C",
  //   icon: "ni ni-active-40 text-info",
  //   component: ActiveCourses,
  //   layout: "/sgk",
  //   exact: true,
  // },
  // {
  //   path: "/calendar",
  //   name: "Calendar",
  //   icon: "ni ni-calendar-grid-58 text-red",
  //   component: Calendar,
  //   layout: "/sgk",
  // },
  {
    path: '/OnlineGames',
    name: 'Profile',
    miniName: 'P',
    icon: 'ni ni-circle-08 text-primary',
    component: OnlineGames,
    layout: '/lms',
    role: '?',
  },
  {
    path: '/sampleTests',
    name: 'Profile',
    miniName: 'P',
    icon: 'ni ni-circle-08 text-primary',
    component: SampleTest,
    layout: '/lms',
    role: '?',
  },
  {
    path: '/sampleTest/:classId/Units',
    name: 'Profile',
    miniName: 'P',
    icon: 'ni ni-circle-08 text-primary',
    component: UnitTest,
    layout: '/lms',
    role: '?',
  },
  {
    path: '/sampleTest/:classId/Unit/:unitId/tests',
    name: 'Profile',
    miniName: 'P',
    icon: 'ni ni-circle-08 text-primary',
    component: Tests,
    layout: '/lms',
    role: '?',
  },
  // testing for components
  // {
  //   collapse: true,
  //   name: "Dashboards",
  //   icon: "ni ni-shop text-primary",
  //   state: "dashboardsCollapse",
  //   views: [
  //     {
  //       path: "/trang-chu",
  //       name: "Dashboard",
  //       miniName: "D",
  //       component: Dashboard,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/alternative-dashboard",
  //       name: "Alternative",
  //       miniName: "A",
  //       component: Alternative,
  //       layout: "/sgk"
  //     }
  //   ]
  // },
  {
    collapse: true,
    name: 'Examples',
    icon: 'ni ni-ungroup text-info',
    state: 'examplesCollapse',
    views: [
      {
        path: '/RegisterStudent',
        name: 'RegisterStudent',
        miniName: 'P',
        component: RegisterStudent,
        layout: '/auth',
      },
      // {
      //   path: '/RegisterTeacher',
      //   name: 'RegisterTeacher',
      //   miniName: 'P',
      //   component: RegisterTeacher,
      //   layout: '/auth',
      // },
      // {
      //   path: '/login',
      //   name: 'Login',
      //   miniName: 'L',
      //   component: Login,
      //   layout: '/auth',
      // },
      // {
      //   path: "/register",
      //   name: "Register",
      //   miniName: "R",
      //   component: Register,
      //   layout: "/auth"
      // },
      // {
      //   path: "/lock",
      //   name: "Lock",
      //   miniName: "L",
      //   component: Lock,
      //   layout: "/auth"
      // },
      //     {
      //       path: "/timeline",
      //       name: "Timeline",
      //       miniName: "T",
      //       component: Timeline,
      //       layout: "/sgk"
      //     },
      //     {
      //       path: "/profile",
      //       name: "Profile",
      //       miniName: "P",
      //       component: Profile,
      //       layout: "/sgk"
      //     },
      //     {
      //       path: "/rtl-support",
      //       name: "RTL Support",
      //       miniName: "RS",
      //       component: RTLSupport,
      //       layout: "/rtl"
      //     }
    ],
  },
  // class

  // {
  //   collapse: true,
  //   name: "Components",
  //   icon: "ni ni-ui-04 text-info",
  //   state: "componentsCollapse",
  //   views: [
  //     {
  //       path: "/buttons",
  //       name: "Buttons",
  //       miniName: "B",
  //       component: Buttons,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/cards",
  //       name: "Cards",
  //       miniName: "C",
  //       component: Cards,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/grid",
  //       name: "Grid",
  //       miniName: "G",
  //       component: Grid,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/notifications",
  //       name: "Notifications",
  //       miniName: "N",
  //       component: Notifications,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/icons",
  //       name: "Icons",
  //       miniName: "I",
  //       component: Icons,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/typography",
  //       name: "Typography",
  //       miniName: "T",
  //       component: Typography,
  //       layout: "/sgk"
  //     },
  //     {
  //       collapse: true,
  //       name: "Multi Level",
  //       miniName: "M",
  //       state: "multiCollapse",
  //       views: [
  //         {
  //           path: "#pablo",
  //           name: "Third level menu",
  //           component: () => {},
  //           layout: "/"
  //         },
  //         {
  //           path: "#pablo",
  //           name: "Just another link",
  //           component: () => {},
  //           layout: "/"
  //         },
  //         {
  //           path: "#pablo",
  //           name: "One last link",
  //           component: () => {},
  //           layout: "/"
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   collapse: true,
  //   name: "Forms",
  //   icon: "ni ni-single-copy-04 text-pink",
  //   state: "formsCollapse",
  //   views: [
  //     {
  //       path: "/elements",
  //       name: "Elements",
  //       miniName: "E",
  //       component: Elements,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/components",
  //       name: "Components",
  //       miniName: "C",
  //       component: Components,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/validation",
  //       name: "Validation",
  //       miniName: "V",
  //       component: Validation,
  //       layout: "/sgk"
  //     }
  //   ]
  // },
  // {
  //   collapse: true,
  //   name: "Tables",
  //   icon: "ni ni-align-left-2 text-default",
  //   state: "tablesCollapse",
  //   views: [
  //     {
  //       path: "/tables",
  //       name: "Tables",
  //       miniName: "T",
  //       component: Tables,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/sortable",
  //       name: "Sortable",
  //       miniName: "S",
  //       component: Sortable,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/react-bs-table",
  //       name: "React BS Tables",
  //       miniName: "RBT",
  //       component: ReactBSTables,
  //       layout: "/sgk"
  //     }
  //   ]
  // },
  // {
  //   collapse: true,
  //   name: "Maps",
  //   icon: "ni ni-map-big text-primary",
  //   state: "mapsCollapse",
  //   views: [
  //     {
  //       path: "/google",
  //       name: "Google",
  //       miniName: "G",
  //       component: Google,
  //       layout: "/sgk"
  //     },
  //     {
  //       path: "/vector",
  //       name: "Vector",
  //       miniName: "V",
  //       component: Vector,
  //       layout: "/sgk"
  //     }
  //   ]
  // },
  // {
  //   path: "/widgets",
  //   name: "Widgets",
  //   icon: "ni ni-archive-2 text-green",
  //   component: Widgets,
  //   layout: "/sgk"
  // },
  // {
  //   path: "/charts",
  //   name: "Charts",
  //   icon: "ni ni-chart-pie-35 text-info",
  //   component: Charts,
  //   layout: "/sgk"
  // },
];
